import { SectionLabel } from "./Disciplines";
import { Wind, Zap, Sun, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const simulations = [
  {
    icon: Wind,
    title: "Simulación de Viento Huracanado ASCE 7",
    desc: "Análisis dinámico de ráfagas de viento de hasta 170+ mph (Categoría 5) sobre estructuras de hormigón reforzado en Puerto Rico. Proyecta vectores de presión aerodinámica y gradientes de velocidad en tiempo real para evitar fallas en techos y voladizos.",
    badge: "Ingeniería Estructural",
    color: "text-cyan-400",
    to: "/herramientas/materials",
    toolName: "Matriz de Materiales & Resistencia",
  },
  {
    icon: Zap,
    title: "Campo Electromagnético Tesla",
    desc: "Simulación virtual de líneas de flujo magnético y propagación de descargas voltaicas de alta tensión y alta frecuencia. Permite analizar el acoplamiento inductivo y la resonancia inalámbrica de bobinas secundarias.",
    badge: "Física y Electrónica",
    color: "text-purple-400",
    to: "/herramientas/arduino",
    toolName: "Suite Arduino, ESP32 & Circuitos",
  },
  {
    icon: Sun,
    title: "Estudio Heliodón y Sombras Proyectadas",
    desc: "Cálculo en tiempo real de la trayectoria solar (azimut y elevación) para optimizar el asoleamiento y la orientación de paneles solares fotovoltaicos. Genera proyecciones de sombras dinámicas sobre el plano del terreno según la hora del día.",
    badge: "Energías y Arquitectura",
    color: "text-amber-400",
    to: "/herramientas/solar",
    toolName: "Central Solar & LiFePO4 PR",
  }
];

export const ScientificSimulations = () => {
  return (
    <section id="simulaciones" className="relative py-32 border-t border-border bg-void/30">
      <div className="absolute inset-0 grid-blueprint opacity-10" />
      <div className="container relative">
        <SectionLabel index="05" title="Simulaciones Científicas" />
        <h2 className="font-serif-display text-4xl md:text-6xl font-light max-w-3xl mb-12 leading-tight">
          Ciencia interactiva. <span className="text-ember italic">Modelado virtual 3D.</span>
        </h2>
        <p className="text-sm text-muted-foreground max-w-2xl mb-16 leading-relaxed">
          Diseñamos simuladores físicos y herramientas visuales embebidas para validar modelos matemáticos de ingeniería, electromagnetismo y termodinámica antes del montaje físico.
        </p>

        <div className="grid md:grid-cols-3 gap-6">
          {simulations.map((sim) => (
            <div
              key={sim.title}
              className="group relative border border-border bg-card/25 backdrop-blur-md p-8 rounded-lg flex flex-col justify-between hover:border-primary/50 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <span className="font-mono-tech text-[8px] uppercase tracking-widest px-2 py-0.5 border border-border rounded text-muted-foreground">
                    {sim.badge}
                  </span>
                  <sim.icon className={`w-5 h-5 ${sim.color} group-hover:scale-110 transition-transform duration-500`} />
                </div>
                
                <h3 className="font-serif-display text-2xl font-light leading-snug">{sim.title}</h3>
                <p className="text-xs text-muted-foreground leading-relaxed">{sim.desc}</p>
              </div>

              <div className="pt-8 mt-6 border-t border-border/30 flex items-center justify-between">
                <span className="text-[10px] text-muted-foreground font-mono-tech truncate max-w-[140px] sm:max-w-none">{sim.toolName}</span>
                <Link
                  to={sim.to}
                  className="inline-flex items-center gap-1.5 text-[9px] font-mono-tech text-primary uppercase group-hover:text-primary-glow font-bold transition-all"
                >
                  <span>Abrir Módulo</span>
                  <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
